import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styles from './devoteeBooking.module.scss';
import LeftMainNavigation from '../../common/leftMenuNavigation/leftMenuNavigation';
import { RoutingURLs } from '../../common/RoutingURLs';
import { apiRequest } from '../../../infrastructure/backendService';
import apiPath from "../../../config/apiPaths.json";
import { leftMenuNavigationListProps } from '../../../infrastructure/GlobalContextProvider';

const DevoteeBooking = () => {
   const navigate = useNavigate();
   const navigateBack = () => {
      navigate(RoutingURLs.dashboard);
   };

   useEffect(() => {
      window.scrollTo(0, 0); // Scroll to the top of the page
      // Find the specific heading element by its ID or class name
      const devoteebooking = document.getElementById('devoteebooking');
      if (devoteebooking) {
         devoteebooking.scrollIntoView({ behavior: 'smooth' }); // Scroll to the top
      }
   }, []);

   const [devoteeMenuList, setDevoteeMenuList] = useState<leftMenuNavigationListProps[]>([]);
   const userRoleId = sessionStorage.getItem("userRoleId");
 
   useEffect(()=>{
      apiRequest({
         method: "GET",
         includeToken: true,
         endpoint: apiPath.administrativeMenus,
         params: {
           categoryId: userRoleId,
           page: 0,
           size: 20,
           direction: "asc"
         },
       })
      .then((res)=>{
         const content = res.data?.content?.find((each: any) => each?.key === "DEVOTEE_SERVICE")
         setDevoteeMenuList(content?.subMenus);
      })
      .catch((err)=>{
         console.log(err)
      })
   },[userRoleId])


   return (
      <div>
         <div className={styles.leftMenuAndContent}>
            <LeftMainNavigation menuList={devoteeMenuList} mainRoutePath='devoteebooking' mainMenuStyle={true} />
            <Outlet />
         </div>
      </div>
   );
};

export default DevoteeBooking;
